export const DATA_LAYER_POLLING_INTERVAL = 10;
export const GTM_ITEMS_CLICKED_STORAGE_KEY = 'gtm_items_clicked';
export const GTM_PROMOTION_CLICKED_FLAG_STORAGE_KEY = 'gtm_promotion_clicked_flag';
export const GTM_PROMOTION_ASSOCIATED_ITEMS_STORAGE_KEY = 'gtm_promotion_associated_items';
export const GTM_ADD_TO_CART_MODAL_ASSOCIATED_ITEMS_STORAGE_KEY = 'gtm_add_to_cart_modal_associated_items';
export const GTM_CUSTOMER_EMAIL_STORAGE_KEY = 'customer-email';
export const GTM_ITEM_CLICKED_EXPIRATION = 24 * 60 * 60;
export const GTM_PROMOTION_ASSOCIATED_ITEM_EXPIRATION = 12 * 60 * 60;
export const GTM_ADD_TO_CART_MODAL_ASSOCIATED_ITEM_EXPIRATION = 12 * 60 * 60;
